import { createStyles, makeStyles } from '@material-ui/core/styles'

import { Theme } from '~/theme/theme'

export const useFinanceSectionStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      calculateBtn: {
        minWidth: '285px',
        fontWeight: 400,

        [theme.breakpoints.down('sm')]: {
          fontWeight: 600
        },
        fontSize: '18px'
      }
    }),
  { name: 'FinanceSection' }
)
